<template>
  <div>
    <div class="alert alert-danger" v-if="false">12/18(金)～1/4(月)にお申し込みの場合、請求書は1/5(火)より順次発送させていただきます。</div>
    <div class="alert alert-danger" v-if="false">お申し込みの受付は、3/2（火）午後1時までとさせていただきます。</div>
    <div class="alert alert-danger" v-if="true">お申し込みの受付は終了いたしました。</div>
  </div>
</template>

<script>
export default {
  name: 'Information'
}
</script>